import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Badge, Modal, Form, Spinner } from "react-bootstrap";
import "../../../assets/css/admin/dashboard/adminblogs/manageblogs.css";
import axios from "axios";
import AppContext from "context/AppContext";
import AdminMasterLayout from "layouts/AdminMasterLayout";
import Blogs from "screens/Buyer/blogs/Blogs";
import { FiEdit, FiEye, FiTrash2 } from "react-icons/fi";
import Swal from "sweetalert2";

const ManageBlogs = () => {
  const { baseUrl, baseUrlForFiles, authToken } = useContext(AppContext);
  const [id, setId] = useState();
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [preview, setPreview] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [blogForEdit, setBlogForEdit] = useState(null);
  const [textForEditAddBlog, setTextForEditAddBlog] = useState("Add");

  const itemsPerPage = 7;

  const totalPages = Math.ceil(blogs.length / itemsPerPage);

  const paginated = blogs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const resetForm = () => {
    setId("");
    setTitle("");
    setImage(null);
    setDescription("");
    setCategory("");
    setStatus(true);
    setPreview(null);
    setBlogForEdit(null);
    setTextForEditAddBlog("Add");
  };
  // Upload Blog
  const uploadBlog = () => {
    if (
      title.trim() === "" ||
      description.trim() === "" ||
      category.trim() === "" ||
      !image
    ) {

      Swal.fire({
        title: "Missing Fields!",
        text: "Please fill all fields before saving the blog.",
        icon: "warning",
        confirmButtonText: "OK"
      });

      return;
    }
    setBtnLoading(true);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("title", title);
    formData.append("image", image);
    formData.append("description", description);
    formData.append("category", category);
    formData.append("status", status);

    axios
      .post(`${baseUrl}/admin/adminblogs/uploadBlog`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
    
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success == true) {
          Swal.fire({
            title: "Congratulations!",
            text: "Blog saved successfully!",
            icon: "success",
            confirmButtonText: "Awesome!"
          });

          viewAllBlogs();
          setBtnLoading(false);
          setShowModal(false);
          resetForm();

          if (response.data.success) {
            setBtnLoading(false);
          }
        }
      })

      .catch((error) => {
        console.log(error);
        setBtnLoading(false);
      });

  };
  // update Blog ----------------
  const updateBlog = () => {
    setBtnLoading(true);
    const formData = new FormData();

    formData.append("id", blogForEdit.id);
    formData.append("title", title);
    formData.append("image", image);
    formData.append("description", description);
    formData.append("category", category);
    formData.append("status", status);

    axios.post(`${baseUrl}/admin/adminblogs/updateBlog`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then((response) => {
        console.log("resposne called", response.data);

        if (response.data.success) {
          viewAllBlogs();
          setShowModal(false);
          setBtnLoading(false);
          resetForm();
          setTextForEditAddBlog("Edit");
        }
      })
      .catch((error) => {
        console.log(error);
        setBtnLoading(false);
      })

  };
  // Delete Blog
  const deleteBlog = (blog) => {
    const formData = new FormData();
    formData.append("id", blog.id);

    axios
      .post(`${baseUrl}/admin/adminblogs/deleteBlog`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then(() => viewAllBlogs())
      .catch((error) => console.log(error));
  };

  // View Blogs
  const viewAllBlogs = () => {
    setTableLoading(true);
    axios
      .get(`${baseUrl}/admin/adminblogs/viewAllBlogs`,{
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then((response) => {
        setBlogs(response.data.blogs || []);
        console.log(response.data.blogs);
        setTableLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setTableLoading(false);
      });
    

  };

  useEffect(() => {
    viewAllBlogs();
  }, []);

  const handleEditblog = (blog) => {
    console.log("***********")
    setTextForEditAddBlog("Edit");
    setShowModal(true);
    setBlogForEdit(blog)
    setTitle(blog.title)
    setImage(blog.image)
    setDescription(blog.description)
    setCategory(blog.category)
    setStatus(blog.status)

  }


  const handleDelete = (blogsId) => {
    const confirmed = window.confirm('Are you sure you want to delete this blogs?');
    if (confirmed) {
      console.log('Deleted Blogs:', blogsId);
      alert('Blog deleted successfully!');
    }
  };

  return (
    <AdminMasterLayout pageTitle="Blogs Management">
      <div className="manage-blogs-page">

        {/* Header */}
        <div className="page-top d-flex justify-content-between mb-4">
          {/* <h2 className="page-title">Blogs Management</h2> */}

          <button
            className="btn-add-blog"
            onClick={() => { setShowModal(true); setTextForEditAddBlog("Add"); resetForm() }}
          >
            <span className="btn-icon">+</span>
            Add Blog
          </button>
        </div>

        {/* Table */}
        <div className="table-card">
          <Table hover responsive className="blogs-table">

            <thead>
              <tr>
                <th>ID</th>
                <th>Image</th>
                <th>Title</th>
                <th>Category</th>
                <th>Description</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Loading Blogs...
                  </td>
                </tr>
              ) : paginated.length > 0 ? (
                paginated.map((blog) => (
                  <tr key={blog.id}>
                    <td className="td-id">{blog.id}</td>
                    <td>
                      <img
                        src={`${baseUrlForFiles}${blog.image}`}
                        style={{ width: "120px", marginTop: "10px", borderRadius: "6px" }}
                      />
                    </td>
                    <td className="td-title">{blog.title}</td>
                    <td>
                      <span className="category-tag">
                        {blog.category}
                      </span>
                    </td>
                    <td className="td-title">{blog.description}</td>
                    <td>
                      <span
                        className={`status-badge ${blog.status ? "published" : "draft"
                          }`}
                      >
                        {blog.status ? "Published" : "Draft"}
                      </span>
                    </td>
                    <td>
                      <div className="sub-actions-cell">
                        <button
                          className="sub-action-btn sub-see-btn"
                          title="View"
                        >
                          <FiEye />
                        </button>
                        <button
                          className="sub-action-btn sub-edit-btn"
                          onClick={() => { handleEditblog(blog); setBlogForEdit(blog) }}
                          title="Edit"
                        >
                          <FiEdit />
                        </button>
                        <button
                          className="sub-action-btn sub-delete-btn"
                          onClick={() => deleteBlog(blog)}
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" align="center">
                    No Blogs Found
                  </td>
                </tr>
              )}


            </tbody>
          </Table>
          {/* Pagination */}

          <div className="table-footer d-flex justify-content-end">

            <button
              className="page-arrow"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ‹
            </button>

            <button className="page-num active">
              {currentPage}
            </button>

            <button
              className="page-arrow"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              ›
            </button>

          </div>

        </div>

        {/* Modal */}

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}

          centered
          className="add-blog-modal"
        >

          <Modal.Header closeButton className="modal-custom-header">
            <Modal.Title className="modal-custom-title">
              {textForEditAddBlog} Blog
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="modal-custom-body">

            <Form>

              <Form.Group className="mb-3">
                <label className="field-label">Title</label>

                <Form.Control
                  className="custom-input"
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

              </Form.Group>

              <Form.Group className="mb-3">

                <label className="field-label">Upload Image</label>

                <Form.Control
                  type="file"
                  className="custom-input"
                  onChange={(e) => {
                    setImage(e.target.files[0]);
                    setPreview(URL.createObjectURL(e.target.files[0]));
                  }}
                />

              </Form.Group>

              <Form.Group className="mb-3">

                <label className="field-label">Description</label>

                <Form.Control
                  as="textarea"
                  rows={3}
                  className="custom-input content-area"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />

              </Form.Group>

              <Form.Group className="mb-3">

                <label className="field-label">Category</label>

                <Form.Select
                  className="custom-input"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="">Select Category</option>
                  <option value="Buying Tips">Buying Tips</option>
                  <option value="Investment">Investment</option>
                  <option value="Selling">Selling</option>
                  <option value="Market Trends">Market Trends</option>
                </Form.Select>

              </Form.Group>

              <Form.Group className="mb-3 d-flex align-items-center gap-3">

                <div
                  className={`toggle-switch ${status ? "active" : ""}`}
                  onClick={() => setStatus(!status)}
                >
                  <div className="toggle-knob"></div>
                </div>

                <span className="toggle-label">
                  {status ? "Published" : "Draft"}
                </span>

              </Form.Group>

              <div className="modal-footer-btns">

                <button
                  type="button"
                  className="btn-save"
                  disabled={btnLoading}
                  onClick={textForEditAddBlog == "Add" ? uploadBlog : updateBlog}
                >
                  {btnLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>

                      {textForEditAddBlog === "Add"
                        ? "Adding..."
                        : "Updating..."}
                    </>
                  ) : (
                    `${textForEditAddBlog} Blog`
                  )}
                </button>
                <button
                  type="button"
                  className="btn-cancel"

                  onClick={() => {
                    setShowModal(false)
                    resetForm();
                  }}

                >
                  Cancel
                </button>

              </div>

            </Form>

          </Modal.Body>

        </Modal>

      </div >
    </AdminMasterLayout>
  );
};

export default ManageBlogs;